export default __webpack_public_path__ + "static/chrisKitten-c975f3a5fa25d003625237b477234e61.mp4";